import { DecimalPipe } from '@angular/common';
import { Component, computed, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MiniGameService } from 'src/app/pages/minigame/minigame.service';
import { BetDetailsComponent } from 'src/app/pages/wallet-history/bet-details/bet-details.component';
import { BetDetailsData } from 'src/app/shared/interfaces/gameorder.interface';
import {
  MatConnectedDialog,
  MatConnectedDialogMobileAnimation,
  MatConnectedDialogRef,
} from 'src/app/shared/service/connected-dialog';
import { LayoutService } from 'src/app/shared/service/layout.service';
@Component({
  selector: 'app-latest-winner-unit',
  templateUrl: './latest-winner-unit.component.html',
  styleUrls: ['./latest-winner-unit.component.scss'],
  providers: [DecimalPipe],
})
export class LatestWinnerUnitComponent implements OnInit {
  constructor(
    private layout: LayoutService,
    private miniGameService: MiniGameService,
    public matConnectedDialog: MatConnectedDialog,
    private decimalPipe: DecimalPipe,
  ) {}

  dialogRef?: MatConnectedDialogRef<BetDetailsComponent>;

  isH5 = toSignal(this.layout.isH5$);

  /**默认图片 */
  defaultImg = computed(() => this.miniGameService.defaultImg);

  url: string = '';
  /**卡片数据 */
  @Input() item: any | null = null;

  /**宽高比 */
  @Input() ratio: number = 1 / 1.333333;

  @Input() index: number = 0;

  /**是否有hover移动一小段距离，只在非h5生效（css里调整了） */
  @Input() hasHover: boolean = true;

  /**是否是用于显示厂商logo */
  @Input() isProvider: boolean = false;

  @Input() isFiatDisplay: boolean = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() beforeClickItem: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() clickItem: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() afterClickItem: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() clickOnDisabled: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  /**
   * 預設圖片
   * 目前沒有預設圖片 先包留功能
   *
   * @param event
   */
  onImageError(event: any) {
    event.target.src = this.miniGameService.defaultImg;
  }

  /**
   * 打開投注詳情
   *
   * @param item
   * @param data
   */
  openBetDetailsDialog(item: any): void {
    const data: BetDetailsData = {
      isSportBet: false,
      gameLogoImgSrc: item.webLogo,
      betAmount: item.betAmount,
      payAmount: item.payAmount,
      multiplier: this.decimalPipe.transform(item.multiplier, '1.2-4') + 'x',
      gameName: item.gameName,
      gameProviderName: item.gameProviderName,
      playerName: item.playerName,
      dateTime: item.dateTime,
      currency: item.currency,
      webRedirectUrl: item?.webRedirectUrl,
      providerCatId: item?.providerCatId,
      gameId: item?.gameId,
    };
    this.dialogRef = this.matConnectedDialog.open(BetDetailsComponent, {
      data,
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
  }

  /**
   * 返回vip等級圖片
   * 目前先+1，因為0是沒有vip等級的
   *
   * @param value
   * @returns
   */
  returnVipImg(value: number) {
    return `assets/images/vip/vip_${value}.png`;
  }
}
